import * as React from 'react';

import { FormValues } from '@funnels/types';
import { FIELD_VALUES } from '@funnels/constants';

import { ConstructionLoanLayout, NewPurchaseLayout, PreapprovalLayout, RefinanceLayout } from './layouts';
import { Panel, PanelHeading } from '../_common/style';

export interface NewLoanPreferencesPanelProps {
  layout: FIELD_VALUES;
  currentValues: FormValues;
}

const NewLoanPreferencesPanel = (props: NewLoanPreferencesPanelProps) => {
  const getLayout = () => {
    switch (props.layout) {
      case FIELD_VALUES.CONSTRUCTION_LOAN:
        return <ConstructionLoanLayout currentValues={props.currentValues} />;
      case FIELD_VALUES.NEW_PURCHASE:
        return <NewPurchaseLayout currentValues={props.currentValues} />;
      case FIELD_VALUES.PREAPPROVAL:
        return <PreapprovalLayout currentValues={props.currentValues} />;
      case FIELD_VALUES.REFINANCE:
        return <RefinanceLayout currentValues={props.currentValues} />;
      default:
        return null;
    }
  };

  return (
    <Panel>
      <PanelHeading>New loan preferences</PanelHeading>
      {getLayout()}
    </Panel>
  );
};

export default NewLoanPreferencesPanel;
